import { RANGE_DATE } from '@/components/FilterBar/constants/filtersConstants';
import { getRangeDateBounds } from '@/components/FilterBar/constants/rangeDateOptions';

export default function buildQuery(selectedIds, filtersBlacklist = []) {
  if (!selectedIds?.length) return '';

  const params = new URLSearchParams();

  selectedIds
    .filter((el) => !filtersBlacklist.includes(el.filter_type))
    .forEach(({ filter_type, id, value }) => {
      if (filter_type === RANGE_DATE) {
        const { date_to, date_from } = getRangeDateBounds({ id, value });

        if (date_from) params.append('date_from', date_from);
        if (date_to) params.append('date_to', date_to);
      } else {
        params.append(filter_type, id);
      }
    });

  const query = params.toString();
  return query ? `?${query}` : '';
}
